import AccountAndPassword from './AccountAndPasswordContainer';

export default AccountAndPassword;
